// import React from "react";
// import { Link } from "react-router-dom";
// import Footer from "../../footer";
// import PageHeader from "../header";

// const TermsCondition = () => {
//   return (
//     <>
//       <div className="main-wrapper">
//         <PageHeader />

//         <div className="breadcrumb-bar">
//           <div className="container">
//             <div className="row">
//               <div className="col-md-12 col-12">
//                 <div className="breadcrumb-list">
//                   <nav aria-label="breadcrumb" className="page-breadcrumb">
//                     <ol className="breadcrumb">
//                       <li className="breadcrumb-item">
//                         <Link to="/home">Home</Link>
//                       </li>
//                       <li className="breadcrumb-item">Pages</li>
//                       <li className="breadcrumb-item">
//                         Terms &amp; Conditions
//                       </li>
//                     </ol>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="page-banner">
//             <div className="container">
//                 <div className="row">
//                     <div className="col-md-12 col-12">
//                         <h1 className="mb-0">Terms &amp; Conditions</h1>
//                     </div>
//                 </div>
//             </div>
//         </div>

//         <div className="page-content">
//             <div className="container">
//                 <div className="row">
//                     <div className="col-lg-12">
//                         <div className="terms-content">
//                             <div className="terms-text">
//                                 <h3>Effective date: <span>15rd of May, 2024</span></h3>
//                                 <h4>This is a H1, Perfect&apos;s for titles.</h4>
//                                 <p>
//                                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
//                                     for the United States element ante. Duis cursus, mi quis viverra
//                                     ornare, eros pain, sometimes none at all, freedom of the living
//                                     creature was as the profit and financial security. Jasmine neck
//                                     adapter and just running it lorem makeup sad smile of the
//                                     television set.
//                                 </p>
//                                 <h5>This is a H2&apos;s perfect for the titles.</h5>
//                                 <p>
//                                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
//                                     for the United States element ante. Duis cursus, mi quis viverra
//                                     ornare, eros pain , sometimes none at all, freedom of the living
//                                     creature was as the profit and financial security. Jasmine neck
//                                     adapter and just running it lorem makeup hairstyle. Now sad smile
//                                     of the television set.
//                                 </p>
//                                 <h5>This is a H2&apos;s perfect for the titles.</h5>
//                                 <p>
//                                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
//                                     for the United States element ante. Duis cursus, mi quis viverra
//                                     ornare, eros pain , sometimes none at all, freedom of the living
//                                     creature was as the profit and financial security. Jasmine neck
//                                     adapter and just running it lorem makeup hairstyle. Now sad smile
//                                     of the television set.
//                                 </p>
//                             </div>
//                             <div className="terms-text">
//                                 <h4>This is a H2&apos;s perfect for the titles.</h4>
//                                 <p>
//                                     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
//                                     for the United States element ante. Duis cursus, mi quis viverra
//                                     ornare, eros pain , sometimes none at all, freedom of the living
//                                     creature was as the profit and financial security. Jasmine neck
//                                     adapter and just running it lorem makeup hairstyle. Now sad smile
//                                     of the television set.
//                                 </p>
//                                 <ul>
//                                     <li>More than 60+ components</li>
//                                     <li>Five ready tests</li>
//                                     <li>Coming soon page </li>
//                                     <li>Check list with left icon</li>
//                                     <li>And much more ...</li>
//                                 </ul>
//                             </div>
//                         <div className="terms-text">
//                             <h4>This is a H2&apos;s perfect for the titles.</h4>
//                             <p>
//                                 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Stress,
//                                 for the United States element ante. Duis cursus, mi quis viverra
//                                 ornare, eros pain , sometimes none at all, freedom of the living
//                                 creature was as the profit and financial security. Jasmine neck
//                                 adapter and just running it lorem makeup hairstyle. Now sad smile
//                                 of the television set.
//                             </p>
//                         </div>
//                         <div className="terms-text">
//                             <h4>Changes about terms</h4>
//                             <p>
//                                 If we change our terms of use we will post those changes on this
//                                 page. Registered users will be sent an email that outlines changes
//                                 made to the terms of use.
//                             </p>
//                             <p>
//                                 Questions? Please email us at 
//                                 <Link to="#"> Ultraaura@example.com</Link>
//                             </p>
//                         </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         <Footer/>
//       </div>
//     </>
//   );
// };

// export default TermsCondition;
import React from "react";
import Footer from "../../footer";
import PageHeader from "../header";

const TermsOfUse = () => {
  return (
    <>
      <div className="main-wrapper">
        <PageHeader />

        <div className="breadcrumb-bar">
          <div className="container">
            <div className="row">
              
            </div>
          </div>
        </div>

        <div className="page-banner">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <h1 className="mb-0">Terms of Use</h1>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="terms-content">
                  <div className="terms-text">
                    <h3>UltraAura Terms of Use</h3>
                    <p>
                      Effective Date: [Jan-01-2024]<br />
                      Last Updated: [Sept-01-2024]
                    </p>
                    <p>
                      Welcome to UltraAura! These Terms of Use (&ldquo;Terms&rdquo;) govern your use of our website, services, and applications (collectively, the &ldquo;Services&rdquo;). By accessing or using our Services, you agree to be bound by these Terms. If you do not agree to these Terms, you must not use our Services.
                    </p>
                  </div>
                  <div className="terms-text">
                    <h3>1. Overview</h3>
                    <p>
                      UltraAura (&ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is an online educational platform based in the United States, serving global customers. We offer courses, skill tests, and certifications to students. Additionally, we partner with trainers and other third-party providers to deliver our Services.
                    </p>
                  </div>
                  <div className="terms-text">
                    <h3>2. Eligibility</h3>
                    <ul>
                      <li>You must be at least 18 years old to create an account or use our Services.</li>
                      <li>If you are under 18, you may only use the Services under the supervision of a parent or legal guardian who agrees to be bound by these Terms.</li>
                    </ul>
                  </div>
                  <div className="terms-text">
                    <h3>3. Account Registration</h3>
                    <ul>
                      <li>To access certain features of our Services, you must create a student account.</li>
                      <li>You agree to provide accurate, current, and complete information during the registration process and update such information to keep it accurate, current, and complete.</li>
                      <li>You are responsible for maintaining the confidentiality of your account credentials and are fully responsible for all activities that occur under your account.</li>
                    </ul>
                  </div>
                  <div className="terms-text">
                    <h3>4. Use of Services</h3>
                    <p>
                      You may use the Services for lawful purposes only. You agree not to engage in any activity that:
                    </p>
                    <ul>
                      <li>Violates any applicable law or regulation.</li>
                      <li>Infringes on the rights of others.</li>
                      <li>Disrupts or interferes with the security or operation of our Services.</li>
                    </ul>
                  </div>
                  <div className="terms-text">
                    <h3>5. Course Enrollment</h3>
                    <ul>
                      <li>When you enroll in a course, you are granted a limited, non-exclusive, non-transferable license to access and view the content for which you have paid all required fees.</li>
                      <li>The course content is for your personal use only and may not be shared with others.</li>
                      <li>We reserve the right to revoke your access to any course content at any time in case of a breach of these Terms.</li>
                    </ul>
                  </div>
                  {/* Add more sections here, following the same pattern */}
                  <div className="terms-text">
                    <h3>6. Contact Information</h3>
                    <p>
                      If you have any questions or concerns about these Terms, please contact us at info@ultraaura.education.
                    </p>
                    <p>
                      By using UltraAura, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use.
                    </p>
                    <p>
                      Please review these Terms regularly to stay informed about any updates.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfUse;